<template>
  <div>
    <StepBack />
    <v-row>
      <v-col cols="12">
        <h3>{{ stepHeader }}</h3>
      </v-col>
      <v-col cols="12">
        <v-alert color="#f6f7f9">
          <strong
            class="d-block px-4"
            v-html="getString(stepContent, 'CVWizard_ImportentTips').Value"
          ></strong>

          <div
            class="px-4"
            v-html="
              getString(stepContent, 'CVWizard_SecondStep_ImportentTipsText')
                .Value
            "
          ></div>
        </v-alert>
      </v-col>
    </v-row>

    <v-form
      id="cvw-step-2"
      ref="cvw-form2"
      v-model="valid"
      class="rtl pa-0 mt-2"
    >
      <div v-for="(education, i) in educationData" :key="`education${i}`">
        <h3 class="display-26 mb-3">
          {{
            getString(stepContent, 'CVWizard_SecondStep_AcademicInstitution')
              .Value
          }}
          <span>#{{ i + 1 }}</span>
        </h3>
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              :label="
                getString(
                  stepContent,
                  'CVWizard_SecondStep_InstitutionNamePlaceHolder'
                ).Value
              "
              :prepend-inner-icon="'mdi-school'"
              solo
              type="text"
              :rules="[]"
              rounded
              :required="false"
              outlined
              dense
              v-model="education.School"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" hidden-sm-and-down class="py-0"></v-col>

          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              :label="
                getString(
                  stepContent,
                  'CVWizard_SecondStep_DiplomaTypePlaceHolder'
                ).Value
              "
              :prepend-inner-icon="'mdi-school'"
              solo
              type="text"
              :rules="[]"
              rounded
              :required="false"
              outlined
              dense
              v-model="education.Diploma"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              :label="
                getString(
                  stepContent,
                  'CVWizard_SecondStep_StudyDomailPlaceHolder'
                ).Value
              "
              :prepend-inner-icon="'mdi-school'"
              solo
              type="text"
              :rules="[]"
              rounded
              :required="false"
              outlined
              dense
              v-model="education.Subject"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="py-0">
                <p class="display-18 font-weight-medium my-0">
                  {{ getString(stepContent, 'CVWizard_From').Value }}
                </p>
                <v-select
                  v-model="education.FromYear"
                  :items="yearRange"
                  light
                  flat
                  outlined
                  solo
                  dense
                  rounded
                  :label="
                    getString(
                      stepContent,
                      'CVWizard_SecondStep_ChooseYearPlaceHolder'
                    ).Value
                  "
                  prepend-inner-icon="mdi-calendar-range"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <p class="display-18 font-weight-medium my-0">
                  {{ getString(stepContent, 'CVWizard_To').Value }}
                </p>
                <v-select
                  v-model="education.ToYear"
                  :items="yearRange"
                  light
                  flat
                  outlined
                  solo
                  dense
                  rounded
                  :label="
                    getString(
                      stepContent,
                      'CVWizard_SecondStep_ChooseYearPlaceHolder'
                    ).Value
                  "
                  prepend-inner-icon="mdi-calendar-range"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" class="py-0">
            <v-textarea
              v-model="education.Description"
              :label="getString(stepContent, 'CVWizard_Description').Value"
              solo
              type="text"
              rounded
              prepend-inner-icon
              outlined
              dense
            ></v-textarea>
          </v-col>
        </v-row>
      </div>
    </v-form>
    <v-row justify="center">
      <v-col text-center>
        <small>
        
        </small>
        <v-btn
          tile
          outlined
          x-large
          width="100%"
          class="display-22 cvw-add-btn"
          elevation="0.4"
          @click="addEducation"
        >
          <v-icon left color="primary">mdi-plus</v-icon>
          {{ getString(stepContent, 'CVWizard_SecondStep_AddEducation').Value }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="text-center my-3">
        <v-btn
          color="primary"
          @click="submit()"
          rounded
          min-width="120"
          :loading="inProgress"
          >{{ getString(stepContent, 'CVWizard_ContinueButton').Value }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CvStepsBase from '../base/CvStepsBase.vue'

export default {
  extends: CvStepsBase,
  components: {},
  props: {},
  data() {
    return {
      valid: true,
      wizardStep: 2,
      inProgress: false,
      currentStep: 'secondstep',
      nextStep: 'thirdstep',
      educationData: [
        {
          Description: '',
          Diploma: '',
          FromYear: null,
          School: '',
          Subject: '',
          ToYear: null,
        },
      ],
    }
  },
  computed: {},
  mounted() {
    const currentStepNumber = this.$router.currentRoute.params.id
    if (
      currentStepNumber == this.wizardStep &&
      this.isInitialized &&
      this.isAvailable &&
      this.isLogged
    ) {
      let payload = { stepname: this.currentStep, data: null }
      this.$store
        .dispatch('updateStepperStatus', payload)
        .then(this.mapStoreData())
    }
  },
  methods: {
    addEducation() {
      this.educationData.push({
        Description: '',
        Diploma: '',
        FromYear: '',
        School: '',
        Subject: '',
        ToYear: '',
      })
    },

    submit() {
      var EducationData = this.getPostDataObject()
      let postdata = {
        EducationData: EducationData,
        Save: true,
      }
      let payload = {
        stepname: this.nextStep,
        data: postdata,
      }
      this.inProgress = true
      this.$store.dispatch('updateStepperStatus', payload).then(() => {
        this.$router.push('/קורות-חיים/3/')
      })
    },

    getPostDataObject() {
      let EducationData = new Array()
      for (var i = 0; i < this.educationData.length; i++) {
        var element = this.educationData[i]
        EducationData.push({
          '<Description>k__BackingField': element.Description,
          '<Diploma>k__BackingField': element.Diploma,
          '<FromYear>k__BackingField': element.FromYear,
          '<School>k__BackingField': element.School,
          '<Subject>k__BackingField': element.Subject,
          '<ToYear>k__BackingField': element.ToYear,
        })
      }

      return EducationData
    },

    mapStoreData() {
      try {
        if (this.stepData && this.stepData.length > 0) {
          this.educationData = this.stepData
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
